export const isDefined = <TType>(arg: any): arg is TType =>
  typeof arg !== 'undefined' && arg !== null

export const isString = (arg: any): arg is string => typeof arg === 'string'

/**
 * This does not check for numbers inside of strings
 */
export const isNumber = (arg: any): arg is number => typeof arg === 'number'

/**
 * Apparently this only checks if an object is not empty
 */
export const isObject = (arg: any) =>
  isDefined<{}>(arg) && typeof arg === 'object' && Object.keys(arg).length > 0

/**
 * This can be empty...
 */
export const isArray = <T>(arg: any): arg is T[] => Array.isArray(arg)
